export default () => {
    
    const scrollTopButton = document.querySelector('.js-scroll-top');
    const animatedCircle = document.querySelector('.js-scroll-top-circle');
    // The following value sets teh distance down the page that you have to
    // scroll before the back to top button is shown.
    const scrollTopOffset = 700;

    // Update progress on scroll and resize events.
    document.addEventListener('scroll', () => {
        // Control visibility of scroll top button.
        if (document.documentElement.scrollTop > scrollTopOffset) {
            scrollTopButton.classList.add('is-active');
        } else {
            scrollTopButton.classList.remove('is-active');
        }

        // Calculate and set svg stroke offset based off scroll position.
        let percentage = (window.scrollY - scrollTopOffset) / (document.documentElement.scrollHeight - scrollTopOffset - window.innerHeight);

        // reset percentage at bottom of page if scrolled more then 100%.
        if (percentage > 1) {
            percentage = 1;
        }
        
        const offset = 302 * percentage;

        animatedCircle.style.strokeDashoffset = 302 - offset;
    });
}
